import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import {Request, GET, PUT} from 'requests';
import {default as RequestsMixin, IS_DONE, HAS_FAILED} from 'requests/RequestsMixin';
import {DELETE} from 'requests/methods';
import {List, Set, Record} from 'immutable';
import {Link, browserHistory} from 'react-router';
import {connect} from 'react-redux';
import {ResourcesMatching, Requesting, Done} from 'requests/components';
import {default as Spinner, SIZE_LARGE} from 'components/Spinner';
import {TYPEFACE_WEIGHTS, TYPEFACE_STYLES} from '../settings';
import * as actions from '../actions';
import RemoveTypefaceModal from './RemoveTypefaceModal';
import {default as PasteOrDropzone, TYPEFACE, DROPZONE} from './PasteOrDropzone';
import Header from './Header';
import TypefacePreview from './TypefacePreview';
import {default as TypefaceSubsetting} from './TypefaceSubsetting';

const UpdateWorkingSetTypeface = Record({
  id: null,
  family: null,
  weight: null,
  style: null,
  subsetting: null,
  characterSets: null,
});

const mapStateToProps = (state, ownProps) => {
  const kitToken = ownProps.params.kitToken;
  const workingSetTypefaceId = ownProps.params.workingSetTypefaceId;

  return {
    kitToken,
    workingSetTypefaceId,
    requests: state.requests,
  };
};

const EditTypefaceController = createReactClass({
  propTypes: {
    dispatch: PropTypes.func.isRequired,
    kitToken: PropTypes.string.isRequired,
    workingSetTypefaceId: PropTypes.string.isRequired,
  },

  mixins: [RequestsMixin, ImmutableRenderMixin],

  getInitialState() {
    return {
      showConfirmDeleteTypeface: false,
      family: '',
      weight: '',
      style: '',
      subsetting: 'none',
      characterSets: Set(),
      deletingFailed: false,
      uploadFailed: false,
      buildFailed: false,
    };
  },

  componentWillMount() {
    const {kitToken, workingSetTypefaceId} = this.props;

    this.setRequest({
      subscription: new Request({
        method: GET,
        url: ['api', 'subscriptions'],
      }),
    });

    this.setRequest({
      kit: new Request({
        method: GET,
        url: ['api', 'kits', kitToken],
      }),
    });

    this.setRequest({
      workingSetTypeface: new Request({
        method: GET,
        url: ['api', 'kits', kitToken, 'working-set-typefaces', workingSetTypefaceId],
      }),
    });

    this.setRequest({
      characterSets: new Request({
        method: GET,
        url: ['api', 'character-sets'],
      }),
    });
  },

  transitions(register) {
    const typefacesPath = `/kits/${this.props.kitToken}/typefaces`;

    register({
      request: this.requests.workingSetTypeface,
      to: IS_DONE,
      call(rm) {
        const workingSetTypeface = rm.type(
          this.requests.workingSetTypeface, 'working-set-typefaces'
        ).get();

        this.setState({
          family: workingSetTypeface.family,
          weight: workingSetTypeface.weight,
          style: workingSetTypeface.style,
          subsetting: workingSetTypeface.subsetting,
          characterSets: Set(workingSetTypeface.characterSets),
        });
      },
    });

    register({
      request: this.requests.updateWorkingSetTypeface,
      to: IS_DONE,
      call(rm) {
        browserHistory.replace(typefacesPath);
      },
    });

    register({
      request: this.requests.updateWorkingSetTypeface,
      to: HAS_FAILED,
      call() {
        this.setState({
          uploadFailed: true,
        });
      },
    });

    register({
      request: this.requests.deleteWorkingSetTypeface,
      to: IS_DONE,
      call() {
        browserHistory.replace(typefacesPath);
      },
    });

    register({
      request: this.requests.deleteWorkingSetTypeface,
      to: HAS_FAILED,
      call() {
        this.setState({
          deletingFailed: true,
        });
      },
    });
  },

  resources() {
    const rm = this.resourceManager();

    return {
      subscription: rm.type(this.requests.subscription, 'subscriptions').get(),
      kit: rm.type(this.requests.kit, 'kits').get(),
      workingSetTypeface: rm.type(this.requests.workingSetTypeface, 'working-set-typefaces').get(),
      characterSets: rm.type(this.requests.characterSets, 'character-sets').all(),
    };
  },

  handleDropzoneInit(dropzone) {
    this.setState({
      dropzone,
    });
  },

  handleFamilyChanged(event) {
    this.setState({
      family: event.target.value,
    });
  },

  handleSubsettingChanged(subsetting) {
    this.setState({
      subsetting,
    });
  },

  handleCharacterSetsChanged(characterSet, isChecked) {
    const {characterSets} = this.state;

    this.setState({
      characterSets: (isChecked) ? characterSets.add(characterSet) : characterSets.delete(characterSet),
    });
  },

  handleWeightChanged(event) {
    this.setState({
      weight: event.target.value,
    });
  },

  handleStyleChanged(event) {
    this.setState({
      style: event.target.value,
    });
  },

  handleEditTypefaceClicked(event) {
    const {kitToken} = this.props;
    const {workingSetTypeface} = this.resources();

    const record = UpdateWorkingSetTypeface({
      id: workingSetTypeface.id,
      family: this.state.family,
      weight: this.state.weight,
      style: this.state.style,
      subsetting: this.state.subsetting,
      characterSets: this.state.characterSets.toArray().join(','),
    });

    event.preventDefault();

    const request = new Request({
      url: ['api', 'kits', kitToken, 'working-set-typefaces', workingSetTypeface.id],
      method: PUT,
      record,
    });

    this.setRequest({
      updateWorkingSetTypeface: request,
    }, {skipDispatch: this.hasFiles()});

    if (this.hasFiles()) {
      this.props.dispatch(
        actions.updateWorkingSetTypeface(request, record, this.state.dropzone)
      );
    }
  },

  hasFiles() {
    const {dropzone} = this.state;

    return (dropzone) ? dropzone.files.length > 0 : false;
  },

  handleDeleteTypefaceClicked(event) {
    event.preventDefault();

    this.setState({
      showConfirmDeleteTypeface: true,
    });
  },

  handleDeleteTypefaceConfirmed() {
    const {workingSetTypeface} = this.resources();

    this.setState({
      showConfirmDeleteTypeface: false,
    });

    this.deleteWorkingSetTypeface(workingSetTypeface);
  },

  handleRemoveFromKitClicked() {
    const {workingSetTypeface} = this.resources();

    this.deleteWorkingSetTypeface(workingSetTypeface);
  },

  deleteWorkingSetTypeface(workingSetTypeface) {
    this.setRequest({
      deleteWorkingSetTypeface: new Request({
        url: ['api', 'kits', this.props.kitToken, 'working-set-typefaces', workingSetTypeface.id],
        method: DELETE,
        record: workingSetTypeface,
      }),
    });
  },

  handleConfirmDeleteTypefaceClosed() {
    this.setState({
      showConfirmDeleteTypeface: false,
    });
  },

  handleFileAdded() {
    this.forceUpdate();
  },

  handleFileRemoved() {
    this.forceUpdate();
  },

  renderError() {
    let error = null;
    const {
      buildFailed,
      uploadFailed,
      deletingFailed,
    } = this.state;

    if (buildFailed || uploadFailed) {
      error = (
        <div id="build-error" className="alert alert-warning" role="alert">
          <strong>Oi!</strong> We had trouble saving your typeface. Why don&rsquo;t you try again.
        </div>
      );
    }

    if (deletingFailed) {
      error = (
        <div id="build-error" className="alert alert-danger" role="alert">
          <strong>Oops!</strong> There was an issue deleting your typeface. Our support team has been notified.
        </div>
      );
    }

    return error;
  },

  renderEditTypefaceButton() {
    const rm = this.resourceManager();
    const workingSetTypefaceUpdating = rm.requests.isQueued(this.requests.updateWorkingSetTypeface);
    const label = (workingSetTypefaceUpdating) ?
      'Saving...' :
      <span>Edit Typeface <i className="ficon ficon-check-circle p-xs-l-xs"></i></span>;

    return (
      <button onClick={this.handleEditTypefaceClicked} className="btn btn-primary btn-block btn-lg" disabled={workingSetTypefaceUpdating}>
        {label}
      </button>
    );
  },

  renderTypefaceSubsetting() {
    const {characterSets} = this.resources();

    return (
      <div className="form-group row required">
        <label className="required col-xs-3 form-control-label p-xs-r-sm">
          Character Subsetting <span title="Required">*</span>
        </label>
        <div className="col-xs-9">
          <TypefaceSubsetting
            subsetting={this.state.subsetting}
            selectedCharacterSetIds={this.state.characterSets}
            characterSets={characterSets}
            onSubsettingChanged={this.handleSubsettingChanged}
            onCharacterSetChanged={this.handleCharacterSetsChanged}
          />
        </div>
      </div>
    );
  },

  renderTypefacePreview() {
    const {workingSetTypeface} = this.resources();

    return (
      <div className="col-xs-6 typeface-asset-preview-rendering">
        <TypefacePreview
          workingSetTypeface={workingSetTypeface}
        />
      </div>
    );
  },

  renderNonCustomTypeface() {
    const {kitToken} = this.props;
    const {workingSetTypeface} = this.resources();

    return (
      <div className="row">
        <div className="col-xs-6">
          <form className="simple_form form-horizontal">
            <div className="form-group row m-xs-b-0">
              <label className="col-xs-3 form-control-label">Family</label>
              <div className="col-xs-9 form-control-static">{workingSetTypeface.family}</div>
            </div>
            <div className="form-group row m-xs-b-0">
              <label className="col-xs-3 form-control-label">Weight</label>
              <div className="col-xs-9 form-control-static">{workingSetTypeface.weight}</div>
            </div>
            <div className="form-group row m-xs-b-0">
              <label className="col-xs-3 form-control-label">Style</label>
              <div className="col-xs-9 form-control-static">{workingSetTypeface.style}</div>
            </div>

            {this.renderTypefaceSubsetting()}

            <div className="form-group row">
              <div className="col-xs-9 col-xs-offset-3">
                {this.renderEditTypefaceButton()}
                <div className="hr m-xs-t-md"><span className="hr-text bg-white">or</span></div>
              </div>
            </div>
          </form>

          <div className="row m-xs-b-lg">
            <div className="col-xs-3 col-xs-offset-3 p-xs-r-sm">
              <Link to={`/kits/${kitToken}/typefaces`} className="btn btn-secondary btn-block btn-lg">Cancel</Link>
            </div>
            <div className="col-xs-6 p-xs-l-0">
              <a onClick={this.handleRemoveFromKitClicked} href="#" className="btn btn-secondary btn-lg">
                Remove from Kit <i className="ficon ficon-times-circle p-xs-l-xs"></i>
              </a>
            </div>
          </div>
        </div>

        {(workingSetTypeface) ? this.renderTypefacePreview() : null}
      </div>
    );
  },

  renderCustomTypeface() {
    const {kitToken} = this.props;
    const {workingSetTypeface} = this.resources();
    const makeOption = (value) => {
      return <option key={value} value={value}>{value}</option>;
    };
    const typefaceErrors = this.resourceManager().requests.errorsFor(this.requests.updateWorkingSetTypeface);
    const weightOptions = TYPEFACE_WEIGHTS.map(makeOption);
    const styleOptions = TYPEFACE_STYLES.map(makeOption);

    return (
      <div className="row">
        <div className="col-xs-6">
          {this.renderError()}

          <form className="simple_form form-horizontal">
            <div className="form-group row string required working_set_typeface_family">
              <label className="string required col-xs-3 form-control-label">
                Family <span title="Required">*</span>
              </label>
              <div className="col-xs-9">
                <input className="string required form-control" onChange={this.handleFamilyChanged} type="text" value={this.state.family} />
                <p className="text-muted p-xs-t-xs">Name of your typeface family. Identical typeface families will be grouped together.</p>
              </div>
            </div>

            <div className="form-group row select required">
              <label className="select required col-xs-3 form-control-label">
                Weight <span title="Required">*</span>
              </label>
              <div className="col-xs-9">
                <select value={this.state.weight} onChange={this.handleWeightChanged} className="select required form-control">
                  {weightOptions}
                </select>
              </div>
            </div>

            <div className="form-group row select required">
              <label className="select required col-xs-3 form-control-label">
                Style <span title="Required">*</span>
              </label>
              <div className="col-xs-9">
                <select value={this.state.style} onChange={this.handleStyleChanged} className="select required form-control">
                  {styleOptions}
                </select>
              </div>
            </div>

            <PasteOrDropzone
              onDropzoneInit={this.handleDropzoneInit}
              onFileAdded={this.handleFileAdded}
              onFileRemoved={this.handleFileRemoved}
              type={TYPEFACE}
              uploadLabel="Replace Original"
              error={(typefaceErrors.first())}
              wrapperClassName="col-xs-9"
              which={DROPZONE}
            />

            {this.renderTypefaceSubsetting()}

            <div className="form-group row">
              <div className="col-xs-9 col-xs-offset-3">
                {this.renderEditTypefaceButton()}
                <div className="hr m-xs-t-md"><span className="hr-text bg-white">or</span></div>
              </div>
            </div>
          </form>
          <div className="row m-xs-b-lg">
            <div className="col-xs-3 col-xs-offset-3 p-xs-r-sm">
              <Link to={`/kits/${kitToken}/typefaces`} className="btn btn-secondary btn-block btn-lg">Cancel</Link>
            </div>
            <div className="col-xs-6 p-xs-l-0">
              <a onClick={this.handleDeleteTypefaceClicked} href="#" className="btn btn-secondary btn-block btn-lg">
                Delete Typeface <i className="ficon ficon-trash p-xs-l-xs"></i>
              </a>

              <RemoveTypefaceModal
                workingSetTypeface={workingSetTypeface}
                show={this.state.showConfirmDeleteTypeface}
                onRemovedTypeface={this.handleDeleteTypefaceConfirmed}
                onClosed={this.handleConfirmDeleteTypefaceClosed}
              />
            </div>
          </div>
        </div>

        {(workingSetTypeface) ? this.renderTypefacePreview() : null}
      </div>
    );
  },

  renderSpinner() {
    return (
      <div className="well bg-white will-fill-page p-xs-a-lg is-loading">
        <Spinner size={SIZE_LARGE} />
      </div>
    );
  },

  renderMain() {
    const {kit, workingSetTypeface} = this.resources();

    return (
      <div className="well bg-white will-fill-page p-xs-a-lg">
        <Link to={`/kits/${kit.token}/typefaces`} className="link-dashed-none">&lsaquo; Back to {kit.name}</Link>
        <Header kit={kit} heading="Edit / View Typeface" headingIcon="ficon-pencil" showUpload={workingSetTypeface.custom} />
        {(workingSetTypeface.custom) ? this.renderCustomTypeface() : this.renderNonCustomTypeface()}
      </div>
    );
  },

  render() {
    const requests = [
      this.requests.subscription,
      this.requests.kit,
      this.requests.workingSetTypeface,
      this.requests.characterSets,
    ];

    return (
      <ResourcesMatching manager={this.resourceManager()}>
        <Requesting any={requests} render={this.renderSpinner} />
        <Done all={requests} render={this.renderMain} />
      </ResourcesMatching>
    );
  },
});

export default connect(mapStateToProps)(EditTypefaceController);



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/EditTypefaceController.js